export function isAlarmNotificationData(data) {
  if (!data || typeof data !== "object") return false;
  const kind = data.kind ?? data.Kind;
  const type = data.type ?? data.Type;
  const mode =
    data.NotificationMode ?? data.notificationMode ?? data.Notification_mode;
  return (
    kind === "alarm" ||
    type === "alarm" ||
    mode === "alarm" ||
    data.channelId === "alarm"
  );
}

export function parseVoiceUrlsFromPushData(data) {
  if (!data || typeof data !== "object") return [];
  const raw = data.voiceUrlsJson ?? data.VoiceUrlsJson;
  if (typeof raw !== "string" || !raw.trim()) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.map((u) => String(u).trim()).filter(Boolean)
      : [];
  } catch {
    return [];
  }
}

export function buildAlarmStateFromPushData(data, title, body, id) {
  const voiceUrls = parseVoiceUrlsFromPushData(data || {});
  return {
    id,
    title,
    body,
    voiceUrls,
    boardId: data.BoardID ?? data.boardId,
    taskId: data.TaskID ?? data.taskId,
    taskMapId: data.TaskMapID ?? data.taskMapId,
    messageId: data.messageId ?? data.MessageId,
  };
}
